import React from "react";

const SonicBoomLocation = () => {
  return (
    <div className="kbl_sonicboom">
      <img
        className="pc"
        src={require("../../assets/img/park/sonicboom_location_map@2x.png")}
        alt="sonicboom_location_map"
      />
      <div className="kbl_sonicboom_location_m">
        <img
          className="m"
          src={require("../../assets/img/park/sonicboom_location_map@2x.png")}
          alt="sonicboom_location_map_m"
        />
      </div>
      <div className="kbl_sonicboom_location">
        <text className="kbl_sonicboom_location_title">수원KT소닉붐아레나</text>
        <text>경기 수원시 권선구 서수원로 577번길 171</text>
        <text>전화 : 031 - 278 - 0010</text>
      </div>
      <div className="kbl_hr" />
      <div className="kbl_sonicboom_location">
        <text className="kbl_sonicboom_location_traffic">대중교통</text>
        <div className="kbl_sonicboom_location_public">
          <div className="kbl_sonicboom_location_station">수원역</div>
          <div className="kbl_sonicboom_location_path">13-4, 9, 13 (가온마을4단지, 서수원칠보체육관 하차)</div>
        </div>
        <div className="kbl_sonicboom_location_public">
          <div className="kbl_sonicboom_location_station">화서역</div>
          <div className="kbl_sonicboom_location_path">19 (가온마을4단지, 서수원칠보체육관 하차)</div>
        </div>
        <div className="kbl_sonicboom_location_public">
          <div className="kbl_sonicboom_location_station">성대역</div>
          <div className="kbl_sonicboom_location_path">62-1, 99, 7800, 7790 (가온마을4단지, 서수원칠보체육관 하차)</div>
        </div>
      </div>
      <div className="kbl_hr" />
      <div className="kbl_sonicboom_location">
        <text className="kbl_sonicboom_location_traffic">자가용</text>
        <div>
          <div className="kbl_sonicboom_location_ic">북수원 IC</div>
          <ul>
            <li className="kbl_sonicboom_location_ic_path">
              <div>ㆍ </div>
              <div>경로1(10.12km) : 경수대로(1.1km) › 서부로(4.5km) › 서수원로577번길(0.8km)</div>
            </li>
            <li className="kbl_sonicboom_location_ic_path">
              <div>ㆍ</div>
              <div>경로2(14.45km) : 경수대로(1.5km) › 과천봉담도시고속화도로(7.0km) › 금곡로(1.3km)</div>
            </li>
            <li className="kbl_sonicboom_location_ic_path">
              <div>ㆍ </div>
              <div>경로3(10.40km) : 경수대로(1.1km) › 서부로(2.4km) › 율전로(1.2km) › 당수로(2.0km)</div>
            </li>
          </ul>
        </div>
        <div>
          <div className="kbl_sonicboom_location_ic">호매실 IC</div>
          <ul>
            <li className="kbl_sonicboom_location_ic_path">
              <div>ㆍ</div>
              <div>
                {" "}
                경로1(3.90km) : 호매실로(0.5km) › 칠보로(1.3km) › 금곡로102번길(1.0km) › 서수원로577번길(0.5km)
              </div>
            </li>
            <li className="kbl_sonicboom_location_ic_path">
              <div>ㆍ</div>
              <div>경로2(3.72km) : 호매실로(0.5km) › 서수원로577번길(1.1km)</div>
            </li>
            <li className="kbl_sonicboom_location_ic_path">
              <div>ㆍ</div>
              <div>경로3(4.72km) : 권선로(1.1km) › Club.KT.서수원로(1.7km) › 서수원로577번길(0.8km)</div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default SonicBoomLocation;
